import { Link } from 'react-router-dom';

const heroImageUrl = 'https://readdy.ai/api/search-image?query=Abstract%20digital%20security%20concept%20with%20warm%20golden%20amber%20tones%2C%20geometric%20shield%20patterns%2C%20soft%20gradient%20background%2C%20clean%20minimal%20composition%2C%20subtle%20glow%20effects%2C%20professional%20atmosphere%2C%20no%20text%2C%20digital%20protection%20theme%2C%20warm%20lighting%2C%20modern%20tech%20aesthetic%2C%20flowing%20lines%2C%20abstract%20network%20nodes&width=1600&height=800&seq=hero-safety-01&orientation=landscape';

export default function Hero() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={heroImageUrl}
          alt="网络安全与合规知识指南"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full h-full flex items-center">
        <div className="max-w-7xl mx-auto px-4 md:px-6 w-full">
          <div className="max-w-2xl">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 mb-6">
              <i className="ri-shield-star-line text-sm text-primary-300"></i>
              <span className="text-xs md:text-sm text-background-50/90">客观 · 专业 · 安全</span>
            </div>
            <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-background-50 leading-tight mb-4">
              成人网站完整指南
              <br />
              <span className="text-primary-300">合规访问与安全须知</span>
            </h1>
            <p className="text-sm md:text-base text-background-50/80 leading-relaxed mb-8 max-w-lg">
              全面客观的信息指引，涵盖合规平台识别、隐私保护、安全访问技巧及法律风险提示，
              帮助你理性、安全地了解相关知识，保护个人信息与设备安全。
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <Link
                to="/category/compliance"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-lg bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-compass-3-line"></i>
                开始探索
              </Link>
              <Link
                to="/about"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-lg bg-background-50/15 backdrop-blur-sm border border-background-50/25 text-background-50 font-medium text-sm hover:bg-background-50/25 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-information-line"></i>
                了解更多
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}